import { Card } from 'design-system'
import { FC, PropsWithChildren } from 'react'

export const BlockedUserCardWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Card className="w-full max-w-120 rounded-lg border-t-8 border-blue-600 p-6 pt-4">
      {children}
    </Card>
  )
}
